import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
export function Focus() {
  const {
    t
  } = useLanguage();
  const items = t('focus.items') || [];
  return <section id="focus" className="py-24 md:py-32 bg-white border-t border-black/5" data-id="element-147">
      <div className="container mx-auto px-6 md:px-12" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-24 text-center" data-id="element-149">
          <p className="text-xs font-semibold tracking-[0.3em] text-gold uppercase mb-4" data-id="element-150">
            {t('focus.eyebrow')}
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-light text-[#0A0A0A]" data-id="element-151">
            {t('focus.heading')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-152">
          {items.map((area: any, index: number) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 border border-black/10 hover:border-gold transition-colors duration-500 bg-white" data-id="element-153">
              <div className="text-sm font-serif italic text-gold mb-6" data-id="element-154">
                0{index + 1}
              </div>
              <h3 className="text-xl font-heading font-medium text-[#0A0A0A] mb-4" data-id="element-155">
                {area.title}
              </h3>
              <p className="text-sm text-black/60 font-light leading-relaxed" data-id="element-156">
                {area.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}